import { render } from "./Prompts.vue?vue&type=template&id=c6e72848"
import script from "./Prompts.vue?vue&type=script&lang=js"
export * from "./Prompts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__